import { isAllOf } from '@reduxjs/toolkit';
import { actionOnMessage } from '@skynet/data-ws-mm';
import { parseResponse } from '@skynet/data-ws-core';
import { selectTargetLoan } from 'src/store/loans/selectors';
import { selectTargetProject } from 'src/store/retainers/selectors';
import { Commands } from './commands';
import { skyRouter } from 'src/routes/sky-router';
import { ApplicationDomain } from 'src/routes/types';
import { addPostAppMiddleware } from './dynamicMiddleware';

const isActionOnMessage = isAllOf(actionOnMessage);

// ex handleWsMessageMiddleware
addPostAppMiddleware((store) => (next) => (action) => {
  if (isActionOnMessage(action)) {
    const { payload } = action;
    const allowedCommands = Object.values(Commands);
    const { json, skipProcessing } = parseResponse(payload, allowedCommands);
    const domain = skyRouter.getDomain();
    if (skipProcessing || !json) {
      return next(action);
    }

    const { id, loanID, projectID } = json;

    let responseLoanId = loanID;
    if (!responseLoanId && domain === ApplicationDomain.Loans) {
      responseLoanId = id;
    }

    let responseProjectId = projectID;
    if (!responseProjectId && domain === ApplicationDomain.Retainers) {
      responseProjectId = id;
    }

    if (responseLoanId) {
      const state = store.getState();
      const currentLoan = selectTargetLoan(state);

      if (currentLoan && +currentLoan !== responseLoanId) {
        return null;
      }

      return next(action);
    }

    if (responseProjectId) {
      const state = store.getState();
      const currentProject = selectTargetProject(state);

      if (currentProject && +currentProject !== responseProjectId) {
        return null;
      }

      return next(action);
    }
  }

  return next(action);
});
